import { FC, useEffect } from 'react';
import toast from 'react-hot-toast';
import { Carousel } from 'antd';
import { getPromo } from 'entities/index';
import { IPromoImage } from 'entities/types';
import { useAppDispatch, useAppSelector } from 'shared/lib';

import { property } from '../constants/property';
import { SliderProvider } from '../providers/SliderProvider';

import styles from './styles.module.scss';

export const Slider: FC = () => {
  const dispatch = useAppDispatch();
  const { images, imagesIsLoading, imagesError } = useAppSelector(
    (state) => state.promoReducer,
  );

  useEffect(() => {
    dispatch(getPromo())
      .unwrap()
      .catch((error) => {
        toast.error(
          error.message || 'Произошла ошибка при загрузке изображений',
        );
      });
  }, [dispatch]);

  if (imagesError || imagesIsLoading) {
    return null;
  }

  return (
    <div>
      <SliderProvider>
        <Carousel {...property} className={styles['slider']}>
          {images.map((image: IPromoImage, index: number) => (
            <div key={index}>
              <div className={styles['slider__item']}>
                <img
                  className={styles['img']}
                  src={image.image_url}
                  alt="Баннер с новостями"
                />
              </div>
            </div>
          ))}
        </Carousel>
      </SliderProvider>
    </div>
  );
};
